/**
 * Show dropdown content.
 */
function display_content() {

    // Captura el ancho de la ventana
    var anchoVentana = window.innerWidth;

    window.onresize = function () {

        anchoVentana = window.innerWidth;
        /* console.log(anchoVentana); */

        onClickContainer();

    };


    function showContent(e) {
        const parentWithClass = e.target.closest('.faq_card');

        const answerCard = parentWithClass.querySelector('.answer_card');

        parentWithClass.classList.toggle("active");

        if (parentWithClass.classList.contains("active")) {
            const contentHeight = answerCard.scrollHeight;
            answerCard.style.maxHeight = contentHeight + "px";
        } else {
            answerCard.style.maxHeight = "0";
        }
    }

    function onClickContainer() {
        if (!!document.querySelector('.faq_card')) {
            const faqs_cards = document.querySelectorAll(".faq_card");
            if (anchoVentana < 768) {
                faqs_cards.forEach(faq => {
                    faq.addEventListener("click", showContent);
                });
            } else {
                faqs_cards.forEach(faq => {
                    faq.removeEventListener("click", showContent);
                });
            }
        }
    }

    onClickContainer();
}

display_content();

export default display_content;